module.exports = __webpack_public_path__ + "img/shopNum8.56b2187f.png";